<template>
  <div>
    <div class="vx-row">

      <div class="vx-col w-full">
        <vx-card title="RAW MATERIAL STOCK" v-can="'view-raw-material-stock-inventory'">
          <template slot="actions">
            <div class="flex">
              <excel-download button_label="Download WIP Stock" :name="'in-progress-work-order-stock'" />
              <vs-button @click.stop="onClickDownloadSheet" class="mr-4 mb-4" color="primary" type="filled">Download Stock Sheet</vs-button>
            </div>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"
                      v-model="filters['search']"
                      class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
            <vs-table id="raw-material-stock-table" max-items="10" :data="staff" :sst="true"  @sort="handleSort"  stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="10%" class="text-xs">ITS PROD CODE</vs-th>
                <vs-th width="20%" class="text-xs">ITS PROD NAME</vs-th>
                <vs-th width="5%" class="text-xs">UNIT</vs-th>
                <vs-th width="10%" class="text-xs" sort-key="current_stock_level">TOTAL STOCK (KG)</vs-th>
                <vs-th width="10%" class="text-xs">AVAILABLE UNALLOCATED STOCK (KG)</vs-th>
                <vs-th width="10%" class="text-xs">WO ALLOCATED STOCK (KG)</vs-th>
                <vs-th width="10%" class="text-xs">ON HOLD STOCK (KG)</vs-th>
                <vs-th width="10%" class="text-xs">EXPIRED STOCK (KG)</vs-th>
                <vs-th width="10%" class="text-xs">REJECT/SUSPENDED STOCK (KG)</vs-th>
                <vs-th width="5%" class="text-xs">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="cursor-pointer" @click.native="onClickViewRmStock(tr.id)" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].company_product_code">
                    <HyperLink :supplier_id="data[indextr].supplier_id" :id="data[indextr].id" type="raw-material">{{ data[indextr].raw_material_code || '' }}</HyperLink>
                  </vs-td>
                  <vs-td :data="data[indextr].company_product_name">
                    {{ data[indextr].raw_material_name ?data[indextr].raw_material_name : '-' }}
                  </vs-td>
                  <vs-td :data="data[indextr].unit">
                    {{ data[indextr].unit }}
                  </vs-td>
                  <vs-td :data="data[indextr].current_stock_level">
                    {{ toFixed(data[indextr].current_stock_level) }}
                  </vs-td>
                  <vs-td :data="data[indextr].available_unallocated_stock">
                    {{ toFixed(data[indextr].available_unallocated_stock) }}
                  </vs-td>
                  <vs-td :data="data[indextr].confirmed_order_stock_allocation">
                    {{ toFixed(data[indextr].confirmed_order_stock_allocation) }}
                  </vs-td>
                  <vs-td :data="data[indextr].on_hold_stock">
                    {{ toFixed(data[indextr].on_hold_stock) }}
                  </vs-td>
                  <vs-td :data="data[indextr].expired_stock">
                    {{ toFixed(data[indextr].expired_stock) }}
                  </vs-td>
                  <vs-td :data="data[indextr].reject_suspended">
                    {{ toFixed(data[indextr].reject_suspended) }}
                  </vs-td>

                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip text="View Stock" position="left">
                        <vs-button class="ml-3"
                                   @click.native="onClickViewRmStock(data[indextr].id)"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
<!--                      <vx-tooltip text="Add Stock" position="left">-->
<!--                        <vs-button class="ml-3"-->

<!--                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-share"></vs-button>-->
<!--                      </vx-tooltip>-->
                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>
            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5">
            </vs-pagination>

          </div>
        </vx-card>
      </div>
    </div>
    <view-raw-material-stock-pop-up ref="viewRawMaterialStockPopUp"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  import ViewRawMaterialStockPopUp from "@/components/popups/inventory/stock/ViewRawMaterialStockPopUp";
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')
  import {defaultPagination, perPageList} from "@/constants/config";

  export default {
    name: 'AllUsersList',
    data () {
      return {
        selected: [],
        updateStaffSelected: [],
        popupActive: false,
        createUserPopupActive: false,
        popUpTitle: '',
        editActive: false,
        edit: null,
        editProp: {},
        checkBox1: false,
        activeConfirm: false,
        staff: [],
        selectedStaff: {},
        createStaffForm: {},
        departments: [],
        users: [],
        filters: { search: '' },
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        supplierId: '',
        perPage: defaultPagination,
        descriptionItems: perPageList,
      }
    },
    components: {
      'v-select': vSelect,
      ViewRawMaterialStockPopUp,

    },
    mixins : [Filter],
    mounted() {
      if (this.$route.query.search ) {
        this.filters['search'] = this.$route.query.search
      }
    },
    methods: {
      async refreshData () {
        await this.loadStaff()
      },
      async loadStaff() {
        await this.$vs.loading({
          container: '#raw-material-stock-table',
          scale: 0.45
        })
        try {
          this.supplierId = this.$route.params.id
          const {data} = await SupplierRawMaterialRepository.getRmListForInventory(
            this.page, this.perPage, this.filterQuery, this.sort
          )
          this.staff =  data.data
          this.meta = data.meta
          this.$router.replace({ query: {} })
        } catch (e) {

        }
        this.$vs.loading.close('#raw-material-stock-table > .con-vs-loading')
      },
      async onClickViewRmStock(id) {
        // const its_prod_code = data.raw_material_category ? data.raw_material_category+'-'+data.raw_material_code : 'N/A'
        // const company_product_name = data.raw_material_name ? data.raw_material_name : 'N/A'
        // const supplier = 'N/A'
        await this.$refs.viewRawMaterialStockPopUp.openPopup(id)
      },
      filterQueryUpdate (){
        this.loadStaff()
      },
      handleChangePage(page) {
        this.page=page;
        this.loadStaff()
      },

      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.loadStaff()
        }

      },
      changePage(index) {
        this.perPage = this.descriptionItems[index]
      },
      statusColorFactory(id) {
        switch (id) {
          case 1:
            return 'warning'
          case 2:
            return 'danger'
          case 3:
            return 'success'
          default:
            return 'danger'
        }
      },
      toFixed(number) {
        return Number(number).toFixed(3)
      },
      async onClickDownloadSheet() {
        try {
          const response = await SupplierRawMaterialRepository.downloadRawMaterialStockSheet()
          let fileURL = window.URL.createObjectURL(new Blob([response.data]));
          let fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', `Raw Material Stock Report.xlsx`);
          document.body.appendChild(fileLink);
          fileLink.click();
        } catch (e) {

        }
      }

    },
    watch : {
      page(){
        this.loadStaff()
      },
      perPage() {
        this.loadStaff()
      }
    }
  }
</script>


<style scoped>

</style>
